import HomeScreenContainer from './HomeScreenContainer';

export default HomeScreenContainer;
